// pattern based on https://stackoverflow.com/a/5717133
const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

export function isURL(url: string) {
  return !!pattern.test(url);
}

export function formatURL(text: string) {
  if (isURL(text)) {
    if (!text.match('^https?://')) {
      return 'http://' + text;
    } else {
      return text;
    }
  } else {
    return `http://${text}`;
  }
}
